import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import kclogo from '../../assets/images/logo/Belur.jpeg';
import './front.css';

const Fppage = () => {
  const navigate = useNavigate();
  const [memberdetails, setMemberdetails] = useState([]);

  useEffect(() => {
    const memberData = localStorage.getItem('memberData');
    const userType = localStorage.getItem('usertype');

    if (userType === 'Member' && memberData) {
      try {
        const parsedData = JSON.parse(memberData);
        setMemberdetails(parsedData);
      } catch (error) {
        console.error('Error parsing member data:', error);
      }
    }
  }, []);

  const handletodayspecial = (data,type,route) => {
    navigate('/member-kot', { state: { heading: data ,type:type} });
    // alert('check')
// navigate(route)

  };
  // /member-kot

  return (
    <div className="card-heading1">
      <div className="heading-h5">
        <div className="pre-dashboard-container">
          <div className="pre-m-triangle"></div>
          <div className="pre-circle">
            <img style={{ width: '120px', height: '120px', borderRadius: '50%' }} src={kclogo} alt="Kerala Club Logo" />
          </div>
          <div className="pre-red-square"></div>
          <div className="pre-header">
            <img
              src="logo-url" // Replace with actual logo URL
              alt="The Belur Club"
              className="club-logo"
            />
          </div>
          <div className="pre-welcome-message">
            <h3 className=" mt-2">Welcome</h3>

            {memberdetails.map((item, index) => (
              <h4 key={index}>Dear {item.membername} </h4>
            ))}
          </div>
          <div className="pre-special-section">
            <div className="pre-btn-div">
              {/* <p style={{margin:0,padding:0,fontWeight:"bold",color:"black"}}> Today's Special</p> */}

              <button className="pre-menu-button" onClick={() => handletodayspecial('Today Special','Special','/todayspl')}>
                <div className="container1">
                  <span role="img" aria-label="special">
                    🌟
                  </span>
                  Today's Special
                </div>
              </button>
              <button className="pre-menu-button" onClick={() => handletodayspecial('Restaurant','CATERING','/resturant')}>
                <div className="container">
                  <span role="img" aria-label="restaurant">
                    🍽️
                  </span>{' '}
                  Restaurant
                </div>
              </button>
              <button className="pre-menu-button" onClick={() => handletodayspecial('MalaBAR','BAR','/malabar')}>
                <div className="container">
                  <span role="img" aria-label="cocktail">
                    🍸
                  </span>{' '}
                  MalaBAR
                </div>
              </button>
            </div>
          </div>
          <div className="pre-dashboard-button-container">
            <button className="pre-dashboard-button" onClick={() => navigate('/member-dashboard')}>
              Dashboard
            </button>
          </div>
          <div className="pre-footer">
            <p style={{ position: 'fixed', bottom: '0%' }}>
              {' '}
              <span className="pre-club">Powered by</span> &nbsp; <span className="pre-clubworld">ClubWorld</span>
            </p>
          </div>
          <div className="pre-inv-m-triangle"></div>
        </div>
      </div>
    </div>
  );
};

export default Fppage;
